import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import "@coreui/icons/css/coreui-icons.css";
import "flag-icon-css/css/flag-icon.min.css";
import "font-awesome/css/font-awesome.min.css";
import "simple-line-icons/css/simple-line-icons.css";
import "@coreui/coreui/dist/css/coreui.min.css";
import "./App.css";
import { Splash } from "./views";
import { Provider } from "react-redux";
import { PrivateRoute } from "./PrivateRoute";
import store from "./store";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/Login"));

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <HashRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <PrivateRoute
                path="/home"
                name="Home"
                component={DefaultLayout}
              />
              <Route
                path="/"
                name="Splash"
                render={(props) => <Splash {...props} />}
              />
            </Switch>
          </React.Suspense>
        </HashRouter>
      </Provider>
    );
  }
}

export default App;
